import {
  createRetryMiddleware,
  createYaAuthMiddleware,
  fetchWithHeaders,
  withCSRF,
  withIdempotency,
  withRequestHasBeenTerminatedRetry,
  withStartup,
  withTimezone,
} from '@logistics-frontend/core/utils/network'
import {flow} from '@logistics-frontend/utils'

import {config} from 'src/shared/config'

const withYaAuth = createYaAuthMiddleware({
  host: config.yaAuthProxy.host,
  headers: Object.assign({
    'Content-Type': 'application/json',
    'Accept-Language': config.lang,
    'X-Taxi': `${navigator.userAgent} turboapp_delivery`,
  }),
})

const withRetry = createRetryMiddleware({retries: 2, delay: 1000})

export const yaAuthFetch = flow(
  withTimezone,
  withYaAuth,
  withCSRF,
  withStartup,
  withIdempotency,
  withRequestHasBeenTerminatedRetry,
  withRetry,
)(fetchWithHeaders)
